import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const UPDATE_TEST_CONFIG_VALUE = `${NAMESPACE}/UPDATE_TEST_CONFIG_VALUE`;
const APPLY_RECENT_CONFIGURATAION = `${NAMESPACE}/APPLY_RECENT_CONFIGURATAION`;
const BROWSER_OPTIONS_FETCH = createApiConstants(`${NAMESPACE}/BROWSER_OPTIONS_FETCH`);
const VIRTUAL_DEVICE_OPTIONS_FETCH = createApiConstants(`${NAMESPACE}/VIRTUAL_DEVICE_OPTIONS_FETCH`);

export default {
  APPLY_RECENT_CONFIGURATAION,
  BROWSER_OPTIONS_FETCH,
  UPDATE_TEST_CONFIG_VALUE,
  VIRTUAL_DEVICE_OPTIONS_FETCH,
};
